<template>
  <div class="pravo-sirsi">
    <div class="pravo-sirsi__welcome">
      <ButtonOverview />
      <Banner />
      <Texts />
      <div class="pravo-sirsi__welcome__version">
        <div class="pravo-sirsi__welcome__version__number">version 1.6.0</div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonOverview from "@/components/welcome/pravo/ButtonOverview.vue";
import Banner from "@/components/welcome/pravo/Banner.vue";
import Texts from "@/components/welcome/pravo/Texts.vue";

export default {
  name: "WelcomeOverview",
  components: {
    ButtonOverview,
    Banner,
    Texts,
  },
};
</script>